import { Link, useLocation } from "react-router-dom";

export default function Logo({ size = 38 }) {
  const { pathname } = useLocation();
  return (
    <Link to="/" data-testid="logo-link" aria-label="Tap In — home" className="inline-flex items-center">
      <span className={`relative inline-flex rounded-full ${pathname === "/sessions" ? "logo-pulse" : ""}`}>
        <img src="/brand/logo-circle.png" alt="Tap In logo" width={size} height={size} className="rounded-full select-none" draggable="false" />
      </span>
    </Link>
  );
}